export default "__VITE_ASSET__lq8KQhca__"